import React, { useCallback, useEffect, useRef, useState } from "react";
import { useModalContext } from "../../../../hooks/modalContext";
import api from "../../../../services/api";
import ButtonIcons from "../../../../shared/components/ButtonIcons";
import EditClausesIcon from "../../assets/icons/EditClausesIcon";
import MoreOptionsIcon from "../../assets/someoptions-icon.svg";
import CloseOptionsIcon from "../../assets/close-icon.svg";
import RemoveClausesIcon from "../../assets/icons/RemoveClausesIcon";
import StarClausesIcon from "../../assets/icons/StarClausesIcon";
import { useAsidebarEditor } from "../../hooks/asidebarEditor";
import { useClausesEditor } from "../../hooks/clausesEditor";
import ButtonPrimary from "../ButtonPrimary";
import IconSvg from "../IconSvg";
import List from "../List";
import ListItem from "../ListItem";
import ListItemBank from "../ListItemBank";
import QuillRenderImage from "../QuillRenderImage";
import { SearchInput } from "../SearchInput";
import { SearchInputBank } from "../SearchInputBank";
import CheckButtonClauses from "../Sidebar/components/CheckButtonClauses";
import CheckClausesContainer from "../Sidebar/components/CheckClausesContainer";
import { ContainerSidebarNav } from "../Sidebar/components/ContainerSidebar/styles";
import { useDetectClickOutside } from "react-detect-click-outside";
import MoonLoader from "react-spinners/MoonLoader";
import { animate, useAnimation, useMotionValue, motion } from "framer-motion";
import Chip from "@mui/material/Chip";
import {
  FlexBar,
  FlexSearch,
  TextContent,
  VStack,
  Text,
  HStack,
  TitleClause,
  DescriptionClause,
  ClausesItemFeatures,
  WrapperClauseBank,
  TitleBankClause,
  ButtonFavoriteBankClause,
  Container,
  ButtonCategories,
  BoxCategories,
  LettersContainer,
  FixedStack,
  SpanClause,
  ContentFilter
} from "./styles";
import useComponentVisible from "../../../../hooks/useComponentVisible";
import CategoriesBox from "../CategoriesBox";
import html2canvas from "html2canvas";

import { useMainHook } from "../../../../hooks/main";
import cloneDeep from "lodash/cloneDeep";
import { ContainerLoading } from "../../screen/styles";
import LoadingEditor from "../LoadingEditor";
import { LoadingSpinner } from "../../../../shared/components/SpinnerLoading";
import CategoriesBoxUser from "../CategoriesBoxUser";
import ListBitsClause from "../ListBitsClause";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";
import { useDiff } from "../../hooks/diffDocuments";
import { useSelection } from "../../hooks/selection";

interface ClausesDataProps {
  id: string;
  user_id: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
  key_words: string;
  created_at: string;
  updated_at: string;
}

interface ClauseObjectProps {
  user_clause_id: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
}

interface IClausesViewProps {
  isActive: boolean;
  handleActiveButton: () => void;
}

interface QueryProps {
  pagination?: number;
  search?: string;
  filter?: string;
  search_key_word?: string;
}

interface QueryBankProps {
  pagination?: number;
  search?: string;
  filter?: string;
  category?: string;
}

interface BankOfClausesProps {
  id: string;
  title: string;
  clause: string;
  description: string;
  key_words: string;
  created_at: string;
  updated_at: string;
  is_favorite: boolean;
}

interface CategoriesProps {
  id: string;
  creator_id: string;
  last_editor_id: string;
  title: string;
  description?: null | string;
  created_at: string;
  updated_at: string;
}

interface MoreOptionsButtonProps {
  index: number;
  active: boolean;
}

interface ParamsCategoriesProps {
  pagination: number;
  filter: string;
}

const ClausesView: React.FC<IClausesViewProps> = ({
  isActive,
  handleActiveButton
}) => {
  const { visibilityIconsOptionsClauses } = useAsidebarEditor();
  const {
    quillRenderImage,
    setClausesObject,
    draggClauseRef,
    clausesObject,
    sourceClause,
    sizeQuillClause,
    dragging,
    setDragging,
    clausesData,
    setClausesData,
    addedClause
  } = useClausesEditor();

  const { setSelectedObject } = useSelection();

  const { handleOpenEditClauseModal } = useModalContext();
  const { handleOpenNewClausesModal, refreshClause, setRefreshClause } =
    useModalContext();
  const [loading, setLoading] = useState(true);
  const [isActiveBoxCategories, setIsActiveBoxCategories] = useState(false);
  const [currentPageCategories, setCurrentPageCategories] = useState(0);
  const [limitPageCategories, setLimitPageCategories] = useState(0);
  const [isActiveBoxUserCategories, setIsActiveBoxUserCategories] =
    useState(false);
  const [dataCategories, setDataCategories] = useState<CategoriesProps[]>([]);
  const [dataCategoriesUser, setDataCategoriesUser] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredFavorites, setFilteredFavorites] = useState(false);

  const [forceUpdate, setForceUpdate] = useState(false);
  const [focusInput, setFocusInput] = useState(false);
  const [showFilter, setShowFilter] = useState("");
  const [showFilterBits, setShowFilterBits] = useState("");
  const [isFavoriteFilter, setIsFavoriteFilter] = useState(false);
  const [currentPageBits, setCurrentPageBits] = useState(0);
  const [isFavoriteFilterBits, setIsFavoriteFilterBits] = useState(false);
  const [loadingBank, setLoadingBank] = useState(true);
  const [paramsCategories, setParamsCategories] = useState({
    pagination: currentPageCategories,
    filter: "all"
  } as ParamsCategoriesProps);

  const [loadingUser, setLoadingUser] = useState(false);
  const [forRefresh, setForRefresh] = useState(false);
  const [paramsCategoriesUser, setParamsCategoriesUser] = useState({
    filter: "all"
  });
  const [bankOfClausesData, setBankOfClausesData] = useState<
    BankOfClausesProps[]
  >([]);

  const { hasGroupShared, whichUserEdited } = useDiff();

  const refUserCategories = useRef(null);

  const list = {
    visible: {
      opacity: 1,
      y: 5,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.3
      }
    },
    hidden: {
      opacity: 0,
      y: -20,
      transition: {
        when: "afterChildren"
      }
    }
  };

  const variants = {
    visible: (i: number) => ({
      opacity: 1,
      transition: {
        delay: i * 0.3
      }
    }),
    hidden: { opacity: 0 }
  };

  const { dragUrl, nameOfCurrentUser } = useMainHook();

  useEffect(() => {
    if (isActive) {
      setCurrentPage(0);
    }
  }, []);

  const handleBoxCategories = useCallback(() => {
    setFocusInput(!focusInput);
    setIsActiveBoxCategories(!isActiveBoxCategories);
  }, [isActiveBoxCategories, focusInput]);

  const handleActiveBoxCategories = useCallback(() => {
    setFocusInput(!focusInput);
    setIsActiveBoxCategories(!isActiveBoxCategories);
  }, [isActiveBoxCategories, focusInput]);

  useEffect(() => {
    if (focusInput) {
      setSelectedObject(null);
    }
  }, [focusInput]);

  const refComponentBoxUser = useRef(null);
  const refComponentBitsClauses = useRef(null);

  document.addEventListener("mousedown", event => {
    if (refComponentBoxUser.current?.contains(event?.target)) {
      return;
    } else {
      if (isActiveBoxUserCategories) {
        setIsActiveBoxUserCategories(false);
      }
    }
  });

  document.addEventListener("mousedown", event => {
    if (refComponentBitsClauses.current?.contains(event?.target)) {
      return;
    } else {
      if (isActiveBoxCategories) {
        setIsActiveBoxCategories(false);
      }
    }
  });

  // //bits clause categories
  // const closeToggle = useCallback(() => {
  //   if (isActiveBoxCategories) {
  //     setIsActiveBoxCategories(false);
  //   }
  // }, [isActiveBoxCategories]);

  // //user clause categories
  // const closeToggleUser = useCallback(() => {
  //   if (isActiveBoxUserCategories) {
  //     setIsActiveBoxUserCategories(false);
  //   }
  // }, [isActiveBoxUserCategories]);

  useEffect(() => {
    const fetchCategoriesUser = async () => {
      try {
        const responseCategoriesUser = await api.get(
          "user-clause/list-array-key-words",
          {
            params: paramsCategoriesUser
          }
        );

        setDataCategoriesUser(oldState => {
          let cloneState = cloneDeep(oldState);

          return [...responseCategoriesUser.data.key_words];
        });
      } catch (err) {
        console.log(err, "error when fetch categories user");
      }
    };

    fetchCategoriesUser();
  }, [isActiveBoxUserCategories, paramsCategoriesUser]);

  const handleOpenBoxUserCategories = useCallback(
    async event => {
      event.preventDefault();
      setFocusInput(!focusInput);
      setIsActiveBoxUserCategories(!isActiveBoxUserCategories);
    },
    [isActiveBoxUserCategories, focusInput, dataCategoriesUser]
  );

  const handleCloseBoxUserCategories = () => {
    setIsActiveBoxUserCategories(false);
    setFocusInput(false);
  };

  const handleFavoriteClauseBits = useCallback(
    async (id: string, object: BankOfClausesProps, index: number) => {
      let optionBoolean = object.is_favorite;

      if (object.is_favorite) {
        try {
          const responseUnfavoriteClause = await api.delete(
            `user-favorite-bits-clause/${id}`
          );
          setForceUpdate(!forceUpdate);
        } catch (err) {
          console.log(err, "error when unfavorite one clause ");
        }
      } else if (!object.is_favorite) {
        try {
          const responseFavoriteClause = await api.post(
            "user-favorite-bits-clause",
            {
              bits_clause_id: id
            }
          );
          setForceUpdate(!forceUpdate);
        } catch (err) {
          console.log(err, "error when favorite one clause as favorite");
        }
      }

      setBankOfClausesData(state => {
        let cloneState = cloneDeep(state);
        cloneState[index].is_favorite = !optionBoolean;
        return cloneState;
      });
    },
    [refreshClause, forceUpdate, bankOfClausesData]
  );

  const [newPageClause, setNewPageClause] = useState<ClausesDataProps[]>([]);
  const [existsNewPage, setExistsNewPage] = useState(false);
  const [runClause, setRunClause] = useState(false);

  const [newPageClauseBits, setNewPageClauseBits] = useState<
    ClausesDataProps[]
  >([]);
  const [existsNewPageBits, setExistsNewPageBits] = useState(false);

  const [objectSpecifClause, setObjectSpecifClause] =
    useState<ClauseObjectProps>({
      user_clause_id: "",
      title: "",
      clause: "",
      description: "",
      is_favorite: false
    });

  const [query, setQuery] = useState<QueryProps>({
    pagination: 0,
    search: "",
    filter: "",
    search_key_word: ""
  });

  const [queryBank, setQueryBank] = useState<QueryBankProps>({
    pagination: 0,
    search: "",
    filter: "",
    category: ""
  });

  const [isActiveOptions, setActiveOptions] = useState<MoreOptionsButtonProps>({
    index: 0,
    active: false
  });

  const handleActiveMoreOptions = (active, index) => {
    setActiveOptions({
      active,
      index
    });
  };

  const handleRemoveClause = useCallback(
    async (id: string) => {
      try {
        const responseRemoveClause = await api.delete(`user-clause/${id}`);
        // setRefreshClause(!refreshClause);
        setClausesData(state => {
          let cloneState = [...state];
          let newArray = cloneState.filter(item => item.id !== id);
          return newArray;
        });
      } catch (err) {
        console.log(err, "error when remove clause");
      }
    },
    [refreshClause, clausesData]
  );

  const handleFavoriteClause = useCallback(
    async (id: string, index?: number) => {
      let title: string = null;
      let clause: string = null;
      let description: string = null;
      let is_favorite: boolean = false;

      try {
        const responseObjectSpecifClause = await api.get(`user-clause/${id}`);
        setObjectSpecifClause(state => {
          let cloneState = { ...state };
          cloneState = responseObjectSpecifClause.data;
          return cloneState;
        });

        title = responseObjectSpecifClause.data.title;
        clause = responseObjectSpecifClause.data.clause;
        description = responseObjectSpecifClause.data.description;
        is_favorite = responseObjectSpecifClause.data.is_favorite;
      } catch (err) {
        console.log(err, "error when transform clause in favorite");
      }

      try {
        const requestFavoriteUpdateClause = await api.put("user-clause", {
          user_clause_id: id,
          title: title,
          clause: clause,
          description: description,
          is_favorite: !is_favorite
        });

        setClausesData(state => {
          let cloneState = [...state];
          cloneState[index].is_favorite = !is_favorite;
          return cloneState;
        });
      } catch (err) {
        console.log(err, "error update favorite clause");
      }
    },
    [objectSpecifClause, refreshClause, query, clausesData]
  );

  //verify if has next page
  useEffect(() => {
    const autoNextPage = async () => {
      setTimeout(async () => {
        try {
          const responseNextPage = await api.get("user-clause", {
            params: {
              pagination: currentPage + 1,
              search: query?.search === "" ? null : query?.search,
              filter: query?.filter === "" ? null : query?.filter,
              search_key_word:
                query?.search_key_word === "" ? null : query?.search_key_word
            }
          });

          if (responseNextPage.status === 200) {
            setNewPageClause(responseNextPage.data.dataArray);
          }
        } catch (err) {
          console.log(err);
        }
      }, 2000);
    };

    autoNextPage();
  }, [currentPage, query]);
  //apply in state if exist newPageClause for true
  useEffect(() => {
    if (newPageClause.length > 0) {
      setExistsNewPage(true);
    } else if (newPageClause.length === 0) {
      setExistsNewPage(false);
    }
  }, [newPageClause]);
  //set pagination query with currentPage with base infinity scroll logic
  useEffect(() => {
    setQuery(state => {
      return {
        ...state,
        pagination: currentPage
      };
    });
  }, [currentPage, isActive]);
  //if favorites, set 0 currentpage
  useEffect(() => {
    if (filteredFavorites) {
      setCurrentPage(0);
    }
  }, [filteredFavorites]);
  //setting main state of myclauses logic
  useEffect(() => {
    const autoLoadClauses = async () => {
      try {
        setLoadingUser(true);
        const responseClauses = await api.get("user-clause", {
          params: {
            pagination:
              query?.search === "" && query?.filter === ""
                ? query?.pagination
                : 0,
            search: query?.search === "" ? null : query?.search,
            filter: query?.filter === "" ? null : query?.filter,
            search_key_word:
              query?.search_key_word === "" ? null : query?.search_key_word
          }
        });
        const newClauses = responseClauses.data.dataArray;
        setClausesData(prevState => {
          if (
            query.pagination !== 0 &&
            query.filter === "" &&
            query.search === "" &&
            query.search_key_word === ""
          ) {
            return [...prevState, ...newClauses];
          }
          let cloneState = [...newClauses];
          return cloneState;
        });

        setLoading(false);
      } catch (err) {
        console.log(err, "error when fetch api clauses route");
      }
    };

    autoLoadClauses();
  }, [query, isActive, addedClause]);

  //useEffect for get categories
  useEffect(() => {
    const autoLoadCategories = async () => {
      try {
        const responseCategories = await api.get("bits-clause-categories", {
          params: {
            pagination: currentPageCategories,
            filter: paramsCategories.filter
          }
        });

        if (responseCategories.data.pagination) {
          setLimitPageCategories(responseCategories.data.pagination);
        }

        if (paramsCategories.filter === "all" && currentPageCategories > 0) {
          setDataCategories(oldState => {
            let cloneState = cloneDeep(oldState);

            return [...cloneState, ...responseCategories.data.dataArray];
          });
        } else {
          setCurrentPageCategories(0);
          setDataCategories(responseCategories.data.dataArray);
        }
      } catch (err) {
        console.log(err, "ERROR WHEN GET CATEGORIES");
      }
    };

    autoLoadCategories();
  }, [paramsCategories, currentPageCategories]);

  const handleGenerateClause = useCallback(
    async (value: string, event, index: number) => {
      dragUrl.current = `richTextClause#@@#${String(Math.random())}`;
      quillRenderImage.current.getEditor().root.style.padding = "0px";
      //verification for don`t get other clause in UI inside of move of user
      if (runClause) return;
      setRunClause(true);
      event.preventDefault();
      setDragging({ active: true, index: index });
      quillRenderImage?.current?.getEditor().setText(value);

      if (hasGroupShared.current) {
        const myContents = quillRenderImage.current.getEditor().getContents();

        myContents.forEach(op => {
          op.attributes = {
            color: "#9945EE"
          };
        });

        quillRenderImage.current.getEditor().setContents(myContents);
      }

      const canvas = await html2canvas(
        quillRenderImage.current.getEditor().root,
        {
          backgroundColor: "rgba(0,0,0,0)"
        }
      );
      if (canvas) {
        setClausesObject(prevState => {
          let cloneState = cloneDeep(prevState);

          return {
            ...cloneState,
            text: value,
            src: canvas.toDataURL(),
            format: hasGroupShared.current
              ? {
                  ops: [
                    {
                      insert: `${value}\n`,
                      attributes: {
                        color: "#9945EE"
                      }
                    }
                  ]
                }
              : {
                  ops: [
                    {
                      insert: `${value}\n`
                    }
                  ]
                },
            initialDelta: hasGroupShared.current
              ? {
                  ops: [
                    {
                      insert: `${value}\n`,
                      attributes: {
                        color: "#9945EE"
                      }
                    }
                  ]
                }
              : "",

            isModify: hasGroupShared.current ? true : null,
            nameOfUserEdited: hasGroupShared.current
              ? nameOfCurrentUser.current
              : "",
            idOfUserEdited: hasGroupShared.current
              ? whichUserEdited.current
              : "",
            isSharedNewText: true
          };
        });

        draggClauseRef.current = canvas.toDataURL();
        setRunClause(false);
      }
    },
    [
      clausesObject,
      sourceClause,
      draggClauseRef,
      quillRenderImage,
      sizeQuillClause,
      dragging,
      refreshClause,
      hasGroupShared
    ]
  );

  const controls = useAnimation();
  const x = useMotionValue(0);

  React.useEffect(() => {
    const controls = animate(x, 100, {
      type: "spring",
      stiffness: 2000
    });

    return controls.stop;
  });

  useEffect(() => {
    if (!loading && existsNewPage && isActive && !filteredFavorites) {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setCurrentPage(prevState => prevState + 1);
        }
      });

      intersectionObserver?.observe(document?.querySelector("#sentinela"));

      return () => intersectionObserver?.disconnect();
    }
  }, [loading, existsNewPage, isActive]);

  useEffect(() => {
    setShowFilter(query.search_key_word);

    if (query.filter === "favorite") {
      setIsFavoriteFilter(true);
    } else {
      setIsFavoriteFilter(false);
    }
  }, [query]);

  ///////////////////////////////////////////////////////////////////////
  //functions of bank of clauses below
  ///////////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (queryBank.filter === "favorite") {
      setCurrentPageBits(0);
      setIsFavoriteFilterBits(true);
    }

    if (queryBank.category !== "") {
      setCurrentPageBits(0);
      setIsFavoriteFilterBits(false);
    }
  }, [queryBank]);

  useEffect(() => {
    setQueryBank(state => {
      return {
        ...state,
        pagination: currentPageBits
      };
    });
  }, [currentPageBits, isActive]);

  useEffect(() => {
    if (isFavoriteFilterBits) {
      setCurrentPage(0);
    }
  }, [isFavoriteFilterBits]);

  useEffect(() => {
    if (!isActiveBoxCategories) {
      setParamsCategories(oldState => {
        return {
          ...oldState,
          filter: "all"
        };
      });
    }
  }, [isActiveBoxCategories]);

  useEffect(() => {
    const autoLoadBankOfClauses = async () => {
      try {
        const responseBankOfClauses = await api.get("bits-clause", {
          params: {
            pagination:
              queryBank?.search === "" &&
              queryBank?.filter !== "favorite" &&
              queryBank.category === ""
                ? queryBank.pagination
                : 0,
            search: queryBank?.search === "" ? null : queryBank.search,
            filter: queryBank?.filter === "" ? null : queryBank.filter,
            category: queryBank?.category === "" ? null : queryBank.category
          }
        });
        let newClauses = responseBankOfClauses.data.dataArray;
        // verify because this useEffect execute two times and occurring issue in this pagination
        setBankOfClausesData(prevState => {
          let cloneState = [...prevState];
          if (
            queryBank.pagination !== 0 &&
            queryBank.filter !== "favorite" &&
            queryBank.category === "" &&
            queryBank.search === ""
          ) {
            return [...cloneState, ...newClauses];
          } else {
            cloneState = [...newClauses];
            return cloneState;
          }
        });

        setLoadingBank(false);
      } catch (err) {
        console.log(err, "error generate list of bank of clauses api");
      }
    };

    autoLoadBankOfClauses();
  }, [queryBank, isActive]);

  useEffect(() => {
    setShowFilterBits(queryBank.category);
    if (queryBank.filter === "favorite") {
      setCurrentPageBits(0);
      setShowFilterBits("favorite");
      setIsFavoriteFilterBits(true);
    } else {
      setIsFavoriteFilterBits(false);
    }
  }, [queryBank]);

  //useEffect for verify if already exists next page for show sentinela
  useEffect(() => {
    const autoNextPage = async () => {
      setTimeout(async () => {
        try {
          const responseNextPage = await api.get("bits-clause", {
            params: {
              pagination: currentPageBits + 1,
              search: queryBank?.search === "" ? null : queryBank.search,
              filter: queryBank?.filter === "" ? null : queryBank.filter,
              category: queryBank?.category === "" ? null : queryBank.category
            }
          });

          if (responseNextPage.status === 200) {
            setNewPageClauseBits(responseNextPage.data.dataArray);
          }
        } catch (err) {
          console.log(err);
        }
      }, 2000);
    };

    autoNextPage();
  }, [currentPageBits, queryBank]);

  //verify if exists really next page
  useEffect(() => {
    if (newPageClauseBits.length > 0) {
      setExistsNewPageBits(true);
    } else if (newPageClauseBits.length === 0) {
      setExistsNewPageBits(false);
    }
  }, [newPageClauseBits, queryBank]);

  console.log(focusInput, "oi");

  useEffect(() => {
    //isactive = tab for clauses of bits
    if (
      !loadingBank &&
      existsNewPageBits &&
      !isActive &&
      !isFavoriteFilterBits
    ) {
      const intersectionObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setCurrentPageBits(prevState => prevState + 1);
        }
      });
      intersectionObserver?.observe(document?.querySelector("#sentinela2"));
      return () => intersectionObserver?.disconnect();
    }
  }, [loadingBank, existsNewPageBits, isActive]);

  return (
    <ContainerSidebarNav scroll="hidden">
      <CheckClausesContainer>
        <CheckButtonClauses
          isActive={isActive}
          label="Minha biblioteca"
          onClick={() => {
            setIsActiveBoxCategories(false);
            handleActiveButton();
          }}
        />
        <CheckButtonClauses
          isActive={!isActive}
          label="Biblioteca UX DOC"
          onClick={() => {
            setIsActiveBoxUserCategories(false);
            handleActiveButton();
          }}
        />
      </CheckClausesContainer>
      {isActive ? (
        // My Clauses
        <Container>
          <VStack
            isModalOpen={isActiveBoxUserCategories}
            className="block-height"
            height="100%"
          >
            <div
              ref={refComponentBoxUser}
              className="wrapper-search-user-clause"
            >
              <FlexSearch width="100%">
                <SearchInput
                  query={query}
                  setQuery={setQuery}
                  label="Pesquisar"
                  focusInput={focusInput}
                  setFocusInput={setFocusInput}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  setClausesData={setClausesData}
                  clausesData={clausesData}
                  filtered={filteredFavorites}
                  setFiltered={setFilteredFavorites}
                  refresh={forRefresh}
                  setRefresh={setForRefresh}
                />
              </FlexSearch>

              {isActiveBoxUserCategories && (
                <CategoriesBoxUser
                  handleBoxCategories={handleCloseBoxUserCategories}
                  dataCategories={dataCategoriesUser}
                  paramsCategories={paramsCategoriesUser}
                  setParamsCategories={setParamsCategoriesUser}
                  query={query}
                  setQuery={setQuery}
                  filtered={filteredFavorites}
                  setFiltered={setFilteredFavorites}
                  ref={refComponentBoxUser}
                  // closeToggleUser={closeToggleUser}
                ></CategoriesBoxUser>
              )}

              <ButtonCategories onClick={handleOpenBoxUserCategories}>
                Categorias
              </ButtonCategories>
            </div>

            {/* render only for transform clause in image for text state */}
            {<QuillRenderImage />}

            {loading ? (
              <ContainerLoading>
                {/* <LoadingEditor /> */}
                <ContractAnimation />
              </ContainerLoading>
            ) : (
              <>
                {showFilter !== "" && !isFavoriteFilter && (
                  <ContentFilter>
                    <div className="chip">
                      <div className="chip-content"> {showFilter} </div>
                      <div
                        className="chip-close"
                        onClick={() => {
                          setQuery(state => {
                            return {
                              ...state,
                              search_key_word: ""
                            };
                          });
                          setFilteredFavorites(false);
                          setCurrentPage(0);
                        }}
                      >
                        <svg
                          className="chip-svg"
                          focusable="false"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                        </svg>
                      </div>
                    </div>
                  </ContentFilter>
                )}

                {query.filter === "favorite" && (
                  <ContentFilter>
                    <div className="chip">
                      <div className="chip-content"> Favoritos </div>
                      <div
                        className="chip-close"
                        onClick={() => {
                          setQuery(state => {
                            return {
                              ...state,
                              filter: ""
                            };
                          });
                          setFilteredFavorites(false);
                          setCurrentPage(0);
                        }}
                      >
                        <svg
                          className="chip-svg"
                          focusable="false"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                        </svg>
                      </div>
                    </div>
                  </ContentFilter>
                )}

                <List
                  isFavoriteFilter={isFavoriteFilter}
                  showFilter={showFilter}
                >
                  {clausesData.length === 0 && (
                    <Container>
                      <Text>Nenhum texto foi encontrado.</Text>
                    </Container>
                  )}

                  {clausesData?.map((item, index) => (
                    <>
                      <ListItem
                        variants={list}
                        initial="hidden"
                        animate="visible"
                        as={motion.div}
                        className="mouse-grab"
                        key={index}
                      >
                        <HStack
                          onDragEnterCapture={e => {
                            if (!dragging.active) {
                              handleGenerateClause(item.clause, e, index);
                            }
                          }}
                          onDragOverCapture={() => {
                            setDragging({ active: false, index: 0 });
                          }}
                          onDragExitCapture={() => {
                            setDragging({ active: false, index: 0 });
                          }}
                        >
                          <SpanClause
                            style={{
                              cursor: "pointer",
                              opacity:
                                dragging.active && index === dragging.index
                                  ? "0.2"
                                  : "1"
                            }}
                            id="rich-text-clause"
                            className="mouse-grab"
                          >
                            {item.title}
                          </SpanClause>

                          {isActiveOptions.active &&
                          isActiveOptions.index === index ? (
                            <ClausesItemFeatures>
                              <ButtonIcons
                                width="30px"
                                onClick={() =>
                                  handleFavoriteClause(item.id, index)
                                }
                              >
                                <StarClausesIcon isActive={item.is_favorite} />
                              </ButtonIcons>
                              <ButtonIcons
                                onClick={() =>
                                  handleOpenEditClauseModal(item.id, index)
                                }
                                margin="0 0 0 10px"
                                width="30px"
                              >
                                <EditClausesIcon />
                              </ButtonIcons>
                              <ButtonIcons
                                margin="0 0 0 10px"
                                width="30px"
                                onClick={() => handleRemoveClause(item.id)}
                              >
                                <RemoveClausesIcon />
                              </ButtonIcons>
                              <ButtonIcons
                                width="30px"
                                margin="0 0 0 10px"
                                onClick={() =>
                                  handleActiveMoreOptions(false, index)
                                }
                              >
                                <IconSvg
                                  src={CloseOptionsIcon}
                                  description=""
                                />
                              </ButtonIcons>
                            </ClausesItemFeatures>
                          ) : (
                            <button
                              style={{
                                border: "transparent",
                                cursor: "pointer",
                                background: "transparent"
                              }}
                              onClick={() =>
                                handleActiveMoreOptions(true, index)
                              }
                            >
                              <IconSvg
                                src={MoreOptionsIcon}
                                description="More options click"
                              />
                            </button>
                          )}
                        </HStack>

                        <DescriptionClause
                          onDragEnterCapture={e =>
                            handleGenerateClause(item.clause, e, index)
                          }
                          style={{
                            opacity:
                              dragging.active && index === dragging.index
                                ? "0.2"
                                : "1"
                          }}
                        >
                          {item.clause}
                        </DescriptionClause>
                        <FlexBar>
                          {visibilityIconsOptionsClauses.visible &&
                            visibilityIconsOptionsClauses.index === index && (
                              <>
                                <ButtonIcons
                                  width="30px"
                                  onClick={() => handleFavoriteClause(item.id)}
                                >
                                  <StarClausesIcon
                                    isActive={item.is_favorite}
                                  />
                                </ButtonIcons>
                                <ButtonIcons
                                  onClick={() =>
                                    handleOpenEditClauseModal(item.id)
                                  }
                                  margin="0 0 0 10px"
                                  width="30px"
                                >
                                  <EditClausesIcon />
                                </ButtonIcons>
                                <ButtonIcons
                                  margin="0 0 0 10px"
                                  width="30px"
                                  onClick={() => handleRemoveClause(item.id)}
                                >
                                  <RemoveClausesIcon />
                                </ButtonIcons>
                              </>
                            )}
                        </FlexBar>
                      </ListItem>
                    </>
                  ))}

                  {existsNewPage && !filteredFavorites && (
                    <li
                      style={{
                        width: "100%",
                        minHeight: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      id="sentinela"
                    >
                      <MoonLoader size={18} color="#000" />
                    </li>
                  )}
                  <li
                    style={{
                      width: "100%",
                      minHeight: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  ></li>
                </List>
              </>
            )}
          </VStack>

          <FixedStack>
            <ButtonPrimary
              className="button-clause-addtext"
              onClick={handleOpenNewClausesModal}
            >
              Cadastrar novo texto
            </ButtonPrimary>
          </FixedStack>
        </Container>
      ) : (
        // Bank of Clauses
        <VStack isModalOpen={isActiveBoxCategories} height="100%">
          <div
            className="container-search-and-category"
            ref={refComponentBitsClauses}
          >
            <FlexSearch width="100%">
              <SearchInputBank
                query={queryBank}
                setQuery={setQueryBank}
                label="Pesquisar"
                focusInput={focusInput}
                setFocusInput={setFocusInput}
                currentPage={currentPageBits}
                setCurrentPage={setCurrentPageBits}
              />

              {/* render only for transform clause in image for text state */}
              {<QuillRenderImage />}

              {isActiveBoxCategories && (
                <CategoriesBox
                  handleBoxCategories={handleBoxCategories}
                  dataCategories={dataCategories}
                  paramsCategories={paramsCategories}
                  setParamsCategories={setParamsCategories}
                  query={queryBank}
                  setQuery={setQueryBank}
                  focusInput={focusInput}
                  setFocusInput={setFocusInput}
                  isFilterBits={isFavoriteFilterBits}
                  setIsFilterBits={setIsFavoriteFilterBits}
                  // closeToggle={closeToggle}
                  pageCurrent={currentPageCategories}
                  setPageCurrent={setCurrentPageCategories}
                  limitPage={limitPageCategories}
                  setLimitPage={setLimitPageCategories}
                ></CategoriesBox>
              )}
            </FlexSearch>

            <ButtonCategories onClick={handleActiveBoxCategories}>
              Categorias
            </ButtonCategories>
          </div>

          {showFilterBits && (
            <ContentFilter>
              <div className="chip2">
                <div className="chip-content2">
                  {" "}
                  {showFilterBits === "favorite"
                    ? "Favoritos"
                    : showFilterBits}{" "}
                </div>
                <div
                  className="chip-close2"
                  onClick={() => {
                    if (showFilterBits === "favorite") {
                      setCurrentPageBits(0);
                      setIsFavoriteFilterBits(false);
                      setQueryBank(state => {
                        return {
                          ...state,
                          category: "",
                          filter: "all"
                        };
                      });

                      return;
                    } else {
                      setIsFavoriteFilterBits(true);
                      setQueryBank(state => {
                        return {
                          ...state,
                          category: ""
                        };
                      });
                      setCurrentPageBits(0);
                    }
                  }}
                >
                  <svg
                    className="chip-svg2"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                  </svg>
                </div>
              </div>
            </ContentFilter>
          )}

          {loadingBank ? (
            <ContainerLoading>
              <LoadingEditor />
            </ContainerLoading>
          ) : (
            <ListBitsClause
              isFavoriteFilter={isFavoriteFilterBits}
              showFilter={showFilterBits}
            >
              {bankOfClausesData.map((item, index) => (
                <ListItemBank
                  variants={list}
                  initial="hidden"
                  animate="visible"
                  as={motion.li}
                >
                  <WrapperClauseBank
                    onDragEnterCapture={e => {
                      if (!dragging.active) {
                        handleGenerateClause(item.clause, e, index);
                      }
                    }}
                    onDragOverCapture={() => {
                      setDragging({ active: false, index: 0 });
                    }}
                  >
                    <TitleBankClause> {item.clause} </TitleBankClause>
                  </WrapperClauseBank>
                  <ButtonFavoriteBankClause
                    onClick={() =>
                      handleFavoriteClauseBits(item.id, item, index)
                    }
                  >
                    <StarClausesIcon isActive={item.is_favorite} />
                  </ButtonFavoriteBankClause>
                </ListItemBank>
              ))}

              {existsNewPageBits && !isFavoriteFilterBits && (
                <li
                  style={{
                    width: "100%",
                    minHeight: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  id="sentinela2"
                >
                  <MoonLoader size={18} color="#000" />
                </li>
              )}
            </ListBitsClause>
          )}
        </VStack>
      )}
    </ContainerSidebarNav>
  );
};

export default ClausesView;
